import { getHours, getMinutes } from 'date-fns';
import { MinuteIncrement } from './types';

export interface TimeContext {
	currentDate: Date;
	currentHour: number;
	currentMinute: number;
	nextValidMinute: number;
}

/**
 * Gets the current time context based on the specified minute increment.
 * @param minuteIncrement - The minute increment to use for calculating the next valid minute e.g. 15 will provide options like 00, 15, 30, 45
 * @returns The current time context including hour and minute information
 */
export const getCurrentTimeContext = (minuteIncrement: MinuteIncrement): TimeContext => {
	const currentDate = new Date();
	const currentHour = getHours(currentDate);
	const currentMinute = getMinutes(currentDate);
	const nextValidMinute = Math.ceil(currentMinute / minuteIncrement) * minuteIncrement;

	return {
		currentDate,
		currentHour,
		currentMinute,
		nextValidMinute,
	};
};
